import { useTranslation } from "react-i18next";
import { HotelCarousel } from "./HotelCarousel";

export const HotelSelectionStep = ({
  inquiryError,
  filteredHotels,
  amenityIcons,
  hotelDistances,
  hotelImageIndices,
  inquiryForm,
  setInquiryForm,
  selectedRooms,
  setSelectedRooms,
  step,
  openModal,
  currentHotelIndex,
  setCurrentHotelIndex,
}) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-4 border-x border-b border-gray-300 p-4 rounded-b-md">
      {inquiryError && (
        <p className="text-red-500 text-center">{inquiryError}</p>
      )}

      <div className="flex flex-col gap-4">
        <div>
          {filteredHotels.length === 0 ? (
            <div className="p-4 bg-gray-100 rounded-md">
              <p className="text-gray-700 mb-2">
                {t("EventPage.noHotelsAvailable")}
              </p>
              <p className="text-gray-700 italic">
                {t("EventPage.clickSendInquiry")}
              </p>
            </div>
          ) : (
            <div className="space-y-4">
              <HotelCarousel
                filteredHotels={filteredHotels}
                amenityIcons={amenityIcons}
                hotelDistances={hotelDistances}
                hotelImageIndices={hotelImageIndices}
                inquiryForm={inquiryForm}
                setInquiryForm={setInquiryForm}
                selectedRooms={selectedRooms}
                setSelectedRooms={setSelectedRooms}
                step={step}
                openModal={openModal}
                currentHotelIndex={currentHotelIndex}
                setCurrentHotelIndex={setCurrentHotelIndex}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
